import logoIndiaToday from "../assets/india-today.png";
import logoThePrint from "../assets/the-print.png";
import logoSpeechTech from "../assets/speech-technology.png";
import logoYourStory from "../assets/yourstory.png";
import logoInc42 from "../assets/inc42.png";
import logoNasscom from "../assets/nasscom.jpeg";
import logoTimesApplaud from "../assets/timesapplaud.png";
import logoSaasNews from "../assets/saasnews.png";
import Card from "./Resources/CardMain";
import { formatDateTime } from "../shared/util/util";

type PressItem = {
  outlet: string;
  title: string;
  url: string;
  logo: string;
  /** ISO date: YYYY-MM-DD */
  date: string;
};

const PRESS_ITEMS: PressItem[] = [
  {
    outlet: "Entrepreneur",
    title: "NASSCOM selects 37 startups for GenAI Cohort 3",
    url: "https://www.entrepreneur.com/en-in/news-and-trends/nasscom-selects-37-startups-for-third-cohort-of-genai/495589",
    logo: logoNasscom,
    date: "2025-08-07",
  },
  {
    outlet: "Inc42",
    title: "Babblebots Inc featured by Inc42 | Startup Stories",
    url: "https://inc42.com/startups/could-this-startups-ai-recruiters-be-the-future-of-hiring/",
    logo: logoInc42,
    date: "2024-11-22",
  },
  {
    outlet: "NASSCOM",
    title:
      "Babblebots.ai Featured in Nasscom’s 2024 Generative AI Startup Landscape Report",
    url: "https://community.nasscom.in/communities/nasscom-insights/indias-generative-ai-startup-landscape-2024",
    logo: logoNasscom,
    date: "2024-11-01",
  },
  {
    outlet: "Inc42",
    title: "30 Startups To Watch: AI picks (Feb 2024)",
    url: "https://inc42.com/startups/30-startups-to-watch-ai-startups-that-caught-our-eyes-in-february-2024/",
    logo: logoInc42,
    date: "2024-03-18",
  },
  {
    outlet: "YourStory",
    title:
      "AI Disruption and No-Code Solutions: Insights from TechSparks Mumbai 2024",
    url: "https://yourstory.com/2024/03/ai-startup-no-code-solutions-techsparks-mumbai-2024",
    logo: logoYourStory,
    date: "2024-03-13",
  },
  {
    outlet: "India Today",
    title:
      "Babblebots.ai Empowers Leading Bank’s Diversity Initiative, Driving Equality for Women",
    url: "https://www.indiatoday.in/pr-newswire?rkey=20231212EN91309&filter=4315",
    logo: logoIndiaToday,
    date: "2023-12-12",
  },
  {
    outlet: "ThePrint",
    title: "Hire 10x faster and cheaper with Babblebots AI",
    url: "https://theprint.in/ani-press-releases/hire-10x-faster-and-cheaper-with-babblebots-ai/1662867/",
    logo: logoThePrint,
    date: "2023-07-10",
  },
  {
    outlet: "The Saas News",
    title: "Babblebots.ai Raises Pre-Seed Funding Round",
    url: "https://www.thesaasnews.com/news/babblebots-ai-raises-pre-seed-funding-round",
    logo: logoSaasNews,
    date: "2023-02-21",
  },
  {
    outlet: "Times Applaud",
    title:
      "Know how Babblebots.ai helps businesses hire faster with new technology",
    url: "https://timesapplaud.com/know-how-babblebots-ai-helps-businesses-hire-faster-with-new-technology/",
    logo: logoTimesApplaud,
    date: "2023-02-17",
  },
  {
    outlet: "Speech Technology",
    title: "Babblebots Launches Voice-Based AI-Recruiter",
    url: "https://www.speechtechmag.com/Articles/ReadArticle.aspx?ArticleID=157153",
    logo: logoSpeechTech,
    date: "2023-02-14",
  },
  {
    outlet: "YourStory",
    title:
      "Using GPT-3, AI AND Voice Tech, this recruitment startup helps companies hire quicker",
    url: "https://yourstory.com/2023/02/recruitment-startup-babblebotsai-uses-gpt3-ai-voice-tech-hiring",
    logo: logoYourStory,
    date: "2023-02-13",
  },
];

// sort newest → oldest
const SORTED_PRESS_ITEMS = [...PRESS_ITEMS].sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
);

export default function PressCards() {
  return (
    <div className="mx-auto grid w-full max-w-max items-start justify-evenly gap-4 px-2 pb-8 sm:grid-cols-2 md:gap-y-5 md:px-0 lg:grid-cols-4">
      {SORTED_PRESS_ITEMS.map((post, idx) => (
        <div  key={post.url} className="h-[24rem] w-full max-w-80 rounded-md border border-gray-500">
          <Card
            link={`${post?.url}`}
            title={post?.title}
            type={"News"}
            image={{
              src: post?.logo,
            }}
            datePublished={formatDateTime(post?.date)}
          />
        </div>
      ))}
    </div>
  );
}
